module.exports = __webpack_public_path__ + "static/assets/8b5629973801cfc9275638668bb37c30.svg";